import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Poppers from "@material-ui/core/Popper";
import PropTypes from "prop-types";
import { Bell, GearSix, SignOut, UserCircle } from "@phosphor-icons/react";

const useStyles = makeStyles({
  wrapper: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  iconBtn: {
    width: "34px",
    height: "34px",
    borderRadius: "9px",
    background: "#ffffff",
    border: "1px solid #e8eef7",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#6b7890",
    position: "relative",
    transition: "all 0.15s",
    "&:hover": { background: "#f0f6ff", color: "#2f72f2" },
  },
  notifDot: {
    position: "absolute",
    top: "7px",
    right: "8px",
    width: "7px",
    height: "7px",
    background: "#ef4444",
    borderRadius: "50%",
    border: "2px solid #fff",
  },
  avatar: {
    width: "34px",
    height: "34px",
    borderRadius: "50%",
    background: "#2f72f2",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontWeight: "800",
    fontSize: "13px",
    fontFamily: '"Inter", "Roboto", sans-serif',
    transition: "box-shadow 0.15s",
    "&:hover": { boxShadow: "0 8px 22px rgba(26,115,232,0.32)" },
  },
  popperNav: {
    zIndex: 1200,
    marginTop: "8px",
  },
  menuPaper: {
    borderRadius: "14px",
    boxShadow: "0 14px 34px rgba(15, 23, 42, 0.14)",
    minWidth: "170px",
    overflow: "hidden",
  },
  menuItem: {
    fontSize: "14px",
    color: "#4a5568",
    padding: "10px 16px",
    gap: "10px",
    fontFamily: '"Inter", "Roboto", sans-serif',
    "&:hover": { background: "#f0f6ff", color: "#1a73e8" },
  },
  menuItemDanger: {
    fontSize: "14px",
    color: "#ef4444",
    padding: "10px 16px",
    gap: "10px",
    fontFamily: '"Inter", "Roboto", sans-serif',
    "&:hover": { background: "#fef2f2" },
  },
});

export default function AdminNavbarLinks({ setLoggedin }) {
  const classes = useStyles();
  const [openProfile, setOpenProfile] = React.useState(null);

  const handleClickProfile = (event) => {
    if (openProfile && openProfile.contains(event.target)) {
      setOpenProfile(null);
    } else {
      setOpenProfile(event.currentTarget);
    }
  };
  const handleCloseProfile = () => setOpenProfile(null);
  const handleLogout = () => {
    setLoggedin(undefined);
    setOpenProfile(null);
  };

  return (
    <div className={classes.wrapper}>
      <button className={classes.iconBtn} type="button">
        <Bell size={18} weight="duotone" />
        <span className={classes.notifDot} />
      </button>
      <button className={classes.iconBtn} type="button">
        <GearSix size={18} weight="duotone" />
      </button>
      <button
        className={classes.avatar}
        type="button"
        aria-owns={openProfile ? "profile-menu-list-grow" : null}
        aria-haspopup="true"
        onClick={handleClickProfile}
      >
        A
      </button>
      <Poppers
        open={Boolean(openProfile)}
        anchorEl={openProfile}
        transition
        disablePortal
        className={classes.popperNav}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            id="profile-menu-list-grow"
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper className={classes.menuPaper}>
              <ClickAwayListener onClickAway={handleCloseProfile}>
                <MenuList role="menu" style={{ padding: "6px" }}>
                  <MenuItem
                    className={classes.menuItem}
                    onClick={handleCloseProfile}
                  >
                    <UserCircle size={17} weight="duotone" /> Profile
                  </MenuItem>
                  <MenuItem
                    className={classes.menuItem}
                    onClick={handleCloseProfile}
                  >
                    <GearSix size={17} weight="duotone" /> Settings
                  </MenuItem>
                  <div
                    style={{
                      height: "1px",
                      background: "#f0f4f8",
                      margin: "4px 0",
                    }}
                  />
                  <MenuItem
                    className={classes.menuItemDanger}
                    onClick={handleLogout}
                  >
                    <SignOut size={17} weight="duotone" /> Log Out
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Poppers>
    </div>
  );
}

AdminNavbarLinks.propTypes = {
  setLoggedin: PropTypes.any,
};
